module.exports = __webpack_public_path__ + "img/ITMGROUPOFINSTITUTIONS.7b134341.png";